import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import i18next from 'i18next';

export type SyncPricesMode = 'overwrite' | 'fill_empty';

interface SyncPricesDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (mode: SyncPricesMode) => void;
}

/**
 * Dialog for syncing offer line item prices from the current active price list.
 * Supports two modes: overwrite all prices, or fill only empty/missing prices.
 */
export default function SyncPricesDialog({ open, onClose, onConfirm }: SyncPricesDialogProps) {
  const [mode, setMode] = useState<SyncPricesMode>('fill_empty');

  const handleConfirm = () => {
    onConfirm(mode);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="sync-prices-dialog-title" maxWidth="sm" fullWidth>
      <DialogTitle id="sync-prices-dialog-title">
        {i18next.t('sync-prices-dialog-title')}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          {i18next.t('sync-prices-dialog-description')}
        </Typography>
        <RadioGroup value={mode} onChange={e => setMode(e.target.value as SyncPricesMode)}>
          <FormControlLabel
            value="fill_empty"
            control={<Radio />}
            label={i18next.t('sync-prices-dialog-fill-empty')}
          />
          <FormControlLabel
            value="overwrite"
            control={<Radio />}
            label={i18next.t('sync-prices-dialog-overwrite')}
          />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} color="secondary">
          {i18next.t('confirmation-dialog-decline')}
        </Button>
        <Button variant="contained" onClick={handleConfirm} color="primary">
          {i18next.t('confirmation-dialog-confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}